var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3791 15H1.19727",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9551 10.605L19.3793 14.985L14.9551 19.3501",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30371 8.04V6.64501C8.30772 5.17964 8.89851 3.7757 9.94657 2.74093C10.9946 1.70615 12.4144 1.12502 13.8946 1.12502H21.2886C22.0201 1.12305 22.7448 1.26399 23.4212 1.53975C24.0976 1.81552 24.7124 2.22075 25.2303 2.73214C25.7483 3.24352 26.1592 3.85101 26.4396 4.51989C26.72 5.18876 26.8643 5.9058 26.8643 6.62999V6.62999V23.34C26.8643 24.808 26.2753 26.2159 25.2268 27.2539C24.1783 28.2919 22.7562 28.875 21.2734 28.875H13.8795C12.4007 28.875 10.9824 28.2935 9.93677 27.2583C8.89111 26.2231 8.30371 24.819 8.30371 23.355V21.945",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/log-in.5db16616149340901af62f5fe4c5b9e4.svg";
export { ForwardRef as ReactComponent };